import { IMAGE_FILE_TYPES, MOVIE_FILE_TYPES } from "../constants";
import { SimpleVideoPlayer } from "./SimpleVideoPlayer";

const SELECTOR = ".js-custom-file";
const SELECT_BUTTON_SELECTOR = ".js-custom-file__select";
const DELETE_BUTTON_SELECTOR = ".js-custom-file__delete";
const FILENAME_SELECTOR = ".js-custom-file__filename";
const THUMBNAIL_SELECTOR = ".js-custom-file__thumbnail";
const HAS_FILE_CLASSNAME = "has-file";

class CustomFileInput {
    static attach() {
        [...document.querySelectorAll(SELECTOR)].forEach((customFileElement) => {
            /* eslint-disable-next-line no-unused-vars */
            const customFile = new CustomFileInput(customFileElement);
        });
    }

    constructor(file) {
        this.wrapperElement = file;
        this.inputElement = this.wrapperElement.querySelector(`[type="file"]`);
        this.hiddenElement = this.wrapperElement.querySelector(`[type="hidden"]`);
        this.selectElement = this.wrapperElement.querySelector(SELECT_BUTTON_SELECTOR);
        this.deleteElement = this.wrapperElement.querySelector(DELETE_BUTTON_SELECTOR);
        this.filenameElement = this.wrapperElement.querySelector(FILENAME_SELECTOR);
        this.thumbnailElement = this.wrapperElement.querySelector(THUMBNAIL_SELECTOR);
        this.file = this.inputElement.dataset.file || null;

        if (this.inputElement) {
            this.inputElement.addEventListener("change", (event) => {
                this.handleInputChange(event);
            });
        }

        if (this.selectElement) {
            this.selectElement.addEventListener("click", (event) => {
                this.handleSelectClick(event);
            });
        }

        if (this.deleteElement) {
            this.deleteElement.addEventListener("click", (event) => {
                this.handleDeleteClick(event);
            });
        }

        this.updateView();
    }

    handleInputChange(event) {
        const file = event.target.files[0];

        if (!file) {
            return;
        }

        this.file = file.name;
        this.updateView();

        const fileReader = new FileReader();
        fileReader.onload = () => {
            if (IMAGE_FILE_TYPES.indexOf(file.type) !== -1) {
                const image = new Image();
                image.src = fileReader.result;
                this.thumbnailElement.replaceChildren(image);
            } else if (MOVIE_FILE_TYPES.indexOf(file.type) !== -1) {
                const video = SimpleVideoPlayer.create(fileReader.result);
                this.thumbnailElement.replaceChildren(video);
            } else {
                // NOTE: for other file type, will not display any preview
            }
        };
        fileReader.readAsDataURL(file);
    }

    handleSelectClick(event) {
        event.preventDefault();
        if (!this.inputElement.disabled) {
            this.inputElement.click();
        }
    }

    handleDeleteClick(event) {
        event.preventDefault();

        this.file = null;
        this.hiddenElement.value = "";
        this.inputElement.value = "";
        this.inputElement.dispatchEvent(new CustomEvent("change"));
        this.updateView();
        this.thumbnailElement.replaceChildren();
    }

    updateView() {
        this.filenameElement.innerText = this.file;

        if (this.file) {
            this.wrapperElement.classList.add(HAS_FILE_CLASSNAME);
        } else {
            this.wrapperElement.classList.remove(HAS_FILE_CLASSNAME);
        }
    }
}

export { CustomFileInput };
